module.exports = __webpack_public_path__ + "img/step-icon-docs.7321424a.svg";